/**
 * @generated SignedSource<<c2128d560d24846b1b201b1b888f781f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type NoteHeaderTitleAndDate_note$data = {
  readonly createdAt: string | null;
  readonly eventEnd: string | null;
  readonly eventGuid: string | null;
  readonly eventStart: string | null;
  readonly id: string;
  readonly noteTitle: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly displayName: string;
    readonly isExternal: boolean;
  };
  readonly url: string | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"NoteHeaderNoteDateOrTimer_note" | "NoteTimeSelectorModal_note">;
  readonly " $fragmentType": "NoteHeaderTitleAndDate_note";
};
export type NoteHeaderTitleAndDate_note$key = {
  readonly " $data"?: NoteHeaderTitleAndDate_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteHeaderTitleAndDate_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteHeaderTitleAndDate_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteTimeSelectorModal_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteHeaderNoteDateOrTimer_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "9470920e2dba3dd888631422cd840098";

export default node;
